import React from "react";
import { SiGoogletranslate } from "react-icons/si";

const BtnLang = () => {
  return (
    <SiGoogletranslate title="Translate this page" style={{ margin: 20 }} />
  );
};

export default BtnLang;
